<div class="page-content">
    <div class="body-data">
        <div class="main">

            <div class="heading">
                <div class="h6">
                    <div class="cls-raw">
                        <span class="text-heading">Raw Material</span>
                        <a class="pointer mt-2" [routerLink]="['/admin/procure']">Back To List</a>
                    </div>
                    <div class="button">
                        <button class="bor-orange mr-3" (click)="saveQuote()">Save</button>
                        <!-- <button  class="bor-orange">Submit</button> -->
                    </div>
                </div>
            </div>
            <div class="row col-md-6">
                <h6 class="mt-2 no-padding">Get Bid</h6>
                <span class="mt-2 cls-draft">RFQ No: {{bidDetails?.bidcode}} (STATUS - {{bidDetails?.bidstatus}})</span>
            </div>
            <div class="cls-lightblue mt-3">
                <div class="pt-2 pb-2 pl-4 pr-2">
                    <p class="text-left  mb-0">With Truventor, you can get cost saving upto 3% on raw material purchase.
                    </p>
                    <p class="text-left  mb-0">Pay through Truventor Finance and save additional 4% annually. Get a
                        Quote Now!</p>
                </div>
            </div>

            <form [formGroup]="quoteForm">
                <div class="content ml-0 mt-3 container-fluid mr-0 no-padding row">
                    <div class="display-flex col-md-12">
                        <div class="col-md-12">
                            <div class="row mb-10">
                                <div class="col-md-4">
                                    <p class="mb-0 regular">
                                        Created Date:
                                    </p>
                                    <p class="mb-0 medium">
                                        {{bidDetails?.createdon | date: 'dd MMM yyyy'}}

                                    </p>
                                </div>
                                <div class="col-md-4">
                                    <p class="mb-0 regular">
                                        Shipping Address:
                                    </p>
                                    <p class="mb-0 medium">
                                        <select name="shippingaddress" formControlName="shippingaddressid"
                                            class="adjustHeight adjust">
                                            <option *ngFor="let addresse of addresses" [value]="addresse.id">
                                                {{addresse.address}}</option>
                                        </select>
                                    </p>
                                </div>
                                <div class="col-md-4">
                                    <p class="mb-0 regular">
                                        Pay
                                    </p>
                                    <p class="mb-0 medium">
                                        <!-- <input type="text" class="form-control" paymentmethodid> -->
                                    </p>
                                </div>
                            </div>

                            <div class="row mb-10">
                                <div class="col-md-8">
                                    <p class="mb-0 regular">
                                        Delivery Date of:
                                    </p>
                                    <p class="ml-2 medium date-picker  row mr-0 ml-0">
                                        <input type="text" formControlName="deliverydate" readonly matInput
                                            [matDatepicker]="startpicker">
                                        <mat-datepicker-toggle class="icon" matSuffix
                                            [for]="startpicker"></mat-datepicker-toggle>
                                        <mat-datepicker #startpicker></mat-datepicker>
                                    </p>
                                </div>

                                <div class="col-md-4">
                                    <p class="mb-0 regular">
                                        <input type="checkbox" id="" name="" value="">
                                    </p>
                                    <p class="mb-0 medium">
                                        Pay with Truventor Credit
                                        <span class="clsblock">(Save upto 4% with T.Credit)</span>
                                    </p>
                                </div>
                            </div>
                            <div class="row mb-10">
                                <div class="col-md-4">
                                    <p class="mb-0 regular">
                                        Customer Name:
                                    </p>
                                    <p class="mb-0 medium">
                                        {{loginName}}
                                    </p>
                                </div>
                                <div class="col-md-4">
                                    <p class="mb-0 regular">
                                        Contact Number
                                    </p>
                                    <p class="mb-0 medium">
                                        <!-- <input type="text" class="form-control" > -->

                                    </p>
                                </div>

                            </div>
                            <div class="row mb-10">
                                <div class="col-md-4">
                                    <p class="mb-0 regular">
                                        RM Supplier Name
                                    </p>
                                    <p class="mb-0 medium">
                                        <!-- <input type="text" class="" formControlName="supplierid"> -->

                                    </p>
                                </div>
                            </div>
                            <div class="row mb-10">
                                <div class="col-md-4">
                                    <p class="mb-0 regular">
                                        Total Items
                                    </p>
                                    <p class="mb-0 medium">
                                        {{bidDetails?.bidItems?.length}}

                                    </p>
                                </div>
                                <div class="col-md-4">
                                    <p class="mb-0 regular">
                                        Name of contact person
                                    </p>
                                    <p class="mb-0 medium">
                                        <input type="text" class="form-control" contactperson>
                                    </p>
                                </div>
                                <div class="col-md-4">
                                    <p class="mb-0 regular">
                                        <input type="checkbox" id="" name="" value="">
                                    </p>
                                    <p class="mb-0 medium">
                                        Others
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="details container-fluid no-padding" style="padding-top: 50px">
                    <div class="parts mt-2 col-md-12 no-padding">
                        <div class="data">
                            <div class="head row ml-0 mr-0">
                                <div class="one ">
                                    <p class="mb-0">S.No</p>
                                </div>
                                <div class="four">
                                    <p class="mb-0">Material Type</p>
                                </div>
                                <div class="four">
                                    <p class="mb-0  mr-2">Description</p>
                                </div>
                                <div class="four">
                                    <p class="mb-0  mr-2">Qty</p>
                                </div>
                                <div class="three">
                                    <p class="mb-0 mr-4">Target Price</p>
                                </div>
                                <!-- <div class="three">
                                    <p class="mb-0 mr-4">Out Price Per kg</p>
                                </div> -->
                                <div class="four">
                                    <p class="mb-0 mr-4">Total Item</p>
                                </div>
                                <div class="three">
                                    <p class="mb-0 mr-4">Delivery Date</p>
                                </div>
                                <div class="four">
                                    <p class="mb-0 mr-4">Comments</p>
                                </div>
                            </div>
                            <div class="body mt-3">
                                <div formArrayName="bidItems">
                                    <div class="row ml-0 mr-0 container-fluid no-padding col-md-12 part"
                                        *ngFor="let item of quoteForm.get('bidItems')['controls']; let i = index"
                                        [formGroupName]="i">
                                        <div class="one">
                                            <p class="mb-0 pl-1 pt-0">{{i+1}}</p>
                                        </div>
                                        <div class="four">
                                            <p class=" ml-2 medium">
                                                <select class="select arrow-img" formControlName="materialtypeid"
                                                    id="materialtypeid" disabled>
                                                    <option value="37">Flat</option>
                                                    <option value="38">Long</option>
                                                    <option value="39">Other</option>
                                                </select>
                                            </p>
                                        </div>
                                        <div class="four">
                                            <p class=" ml-2 medium">
                                                <input type="text" class="form-control"
                                                    formControlName="mategrialdescription" disabled>
                                            </p>
                                        </div>
                                        <div class="four">
                                            <p class=" ml-2 medium">
                                                <input type="number" class="form-control" formControlName="quantity"
                                                    disabled>
                                            </p>
                                        </div>
                                        <!-- <div class="three">
                                            <p class=" ml-2 medium">
                                                <input type="text" class="form-control" disabled>
                                            </p>
                                        </div> -->
                                        <div class="three">
                                            <p class=" ml-2 medium">
                                                <input type="number" class="form-control" formControlName="priceperkg"
                                                    disabled>
                                            </p>
                                        </div>
                                        <div class="four">
                                            <p class=" ml-2 medium">
                                                <input type="text" class="form-control" formControlName="itemcost"
                                                    (change)="changeItemCost(i, $event)">
                                            </p>
                                        </div>
                                        <div class="three">
                                            <p class="ml-2 medium date-picker  row mr-0 ml-0">
                                                <input type="text" formControlName="targetdate" readonly matInput
                                                    [matDatepicker]="startpicker">
                                                <mat-datepicker-toggle class="icon" matSuffix
                                                    [for]="startpicker"></mat-datepicker-toggle>
                                                <mat-datepicker #startpicker></mat-datepicker>
                                            </p>
                                        </div>
                                        <div class="four">
                                            <p class=" ml-2 medium">
                                                <input type="text" class="form-control" formControlName="comments">
                                            </p>
                                        </div>
                                        <!-- <div class="four">
                                            <p class="ml-2 medium remove">
                                                <i class="fa fa-plus mr-1" aria-hidden="true"
                                                    (click)="addItemsArray()"></i>
                                                <i class="fa fa-trash mr-1" aria-hidden="true"
                                                    (click)="removeItems(i)"></i>
                                            </p>
                                        </div> -->
                                    </div>
                                </div>
                                <div class="subtotal">
                                    <div class="head1">
                                        <p>
                                            subtotal : {{totalCost}}
                                        </p>
                                        <p>
                                            Target Shipping : RFQ
                                        </p>
                                        <p class="no-bor">
                                            Tax Percentage : <input type="text" class="form-control"
                                                formControlName="totaltax" (change)="changeTaxAmount($event)">
                                        </p>
                                        <p class="no-bor">
                                            Tax Amount : <input type="text" class="form-control" formControlName="taxes"
                                                disabled>
                                        </p>

                                    </div>
                                </div>
                                <div class="comment row ml-0 mr-0">
                                    <div class="heading">
                                        <p class="mt-2 mb-0">*COMMENT</p>
                                    </div>
                                    <div class="vendor-comments">
                                        <p class="mt-2 mb-0">{{bidDetails?.comments}}</p>
                                    </div>
                                </div>
                                <br>

                            </div>
                        </div>
                    </div>
                </div>
            </form>
        </div>
    </div>